import { defineAsyncComponent, shallowRef, type ShallowRef } from "vue";
import type { ComponentMap } from "~/modules/dtwin/models/ComponentMap.interface";

/**
 * Component map to load dynamic components
 * from UI Config
 * We use dynamic import to avoid loading
 * if not used
 */
export function useComponentMap(): { componentMap: ShallowRef<ComponentMap> } {
  const componentMap: ShallowRef<ComponentMap> = shallowRef<ComponentMap>({
    DtwinTypeLabel: defineAsyncComponent(
      () =>
        import(
          "~/modules/dtwin/components/formattingProcess/DtwinTypeLabel.vue"
        ),
    ),
    DtwinSector: defineAsyncComponent(
      () =>
        import("~/modules/dtwin/components/formattingProcess/DtwinSector.vue"),
    ),
    DtwinListConnectivityStatus: defineAsyncComponent(
      () =>
        import(
          "~/modules/dtwin/components/formattingProcess/DtwinListConnectivityStatus.vue"
        ),
    ),
    DtwinIsoDate: defineAsyncComponent(
      () =>
        import("~/modules/dtwin/components/formattingProcess/DtwinIsoDate.vue"),
    ),
    DtwinListMetadataStatus: defineAsyncComponent(
      () =>
        import(
          "~/modules/dtwin/components/formattingProcess/DtwinListMetadataStatus.vue"
        ),
    ),
    DtwinCertificateRange: defineAsyncComponent(
      () =>
        import(
          "~/modules/dtwin/components/formattingProcess/DtwinCertificateRange.vue"
        ),
    ),
    DtwinFormDescriptionGeolocationStatus: defineAsyncComponent(
      () =>
        import(
          "~/modules/dtwin/components/formattingProcess/DtwinFormDescriptionGeolocationStatus.vue"
        ),
    ),
    DtwinFormDescriptionGeolocationMap: defineAsyncComponent(
      () =>
        import(
          "~/modules/dtwin/components/formattingProcess/DtwinFormDescriptionGeolocationMap.vue"
        ),
    ),
    DtwinFormS4AdditionalMetadata: defineAsyncComponent(
      () =>
        import("~/modules/dtwin/components/DtwinFormS4AdditionalMetadata.vue"),
    ),
  });

  return {
    componentMap,
  };
}
